/**
 * Insight Config API path.
 * List, get-by-id, create, and update: /sxcl/v1/insights/config
 */
const BASE = '/sxcl/v1';
const INSIGHTS_CONFIG_PATH = `${BASE}/insights/config`;

export default INSIGHTS_CONFIG_PATH;
